import { render, staticRenderFns } from "./categorizeList.vue?vue&type=template&id=085a0645&scoped=true"
import script from "./categorizeList.vue?vue&type=script&lang=js"
export * from "./categorizeList.vue?vue&type=script&lang=js"
import style0 from "./categorizeList.vue?vue&type=style&index=0&id=085a0645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085a0645",
  null
  
)

export default component.exports